<template>
    <div class="vd__body">
        <div class="vd__header">
            <main-menu/>
        </div>
        <div class="vd__page_body">
            <router-view/>
        </div>
    </div>
</template>

<script>
import menu from '../components/menu.vue';

export default {
  components: {
    'main-menu': menu,
  },
};
</script>


<style>
html, body{
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    font-size: 13px;
}

* {
    font-family: 'Inter', sans-serif;
    font-display: auto;
    font-size: 13px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    box-sizing: border-box;
}

button{
    cursor: pointer;
}

@supports (font-variation-settings: normal) {
  * { font-family: 'Inter var', sans-serif; }
}

:root{
    --primary: #005bea;
    --secondary: #3d25ff;
    --color: #2d3645;
    --border: 1px solid #e6e6e6;
    --shadow: 0 7px 14px 0 rgba(59, 65, 94, 0.03), 0 3px 6px 0 rgba(0, 0, 0, 0);
}

.vd__body{
    width: 100%;
    height: 100%;
}

.vd__header{
    width: 100%;
    height: 75px;
    background: linear-gradient(to left, #3d25ff 0%, #005bea 100%);
}

.vd__page_body{
    width: 100%;
    height: calc(100% - 75px);
    overflow-y: auto;
    overflow-x: hidden;
    background: #f5f6f8;
    padding: 35px 3%;
}

.vd__tooltip_text{
    font-size: 0.8em;
}

.vd__box.no-padding .vd__box_body {
  padding: 0 !important;
}
</style>
